import React, { useEffect, useState } from "react";
import { Recycle, Trash } from "lucide-react";
import { api, fmtDate } from "../../lib/api";
import { PageHeader, Panel } from "../../lib/ui";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";

const num = (n) => (Number(n) || 0).toLocaleString("id-ID", { maximumFractionDigits: 2 });

export default function FabricReturns() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/production/fabric-returns").then((r) => setData(r.data)); }, []);
  return (
    <div data-testid="fabric-returns-page">
      <PageHeader title="Sisa Kain" subtitle="Pertanggungjawaban material: retur sisa kain & waste dari cutting/konveksi" />
      <div className="grid grid-cols-2 gap-3 mb-5 max-w-md">
        <div className="bg-white border border-taupe/20 rounded-lg p-4"><div className="text-xs text-wmuted flex items-center gap-1.5"><Recycle className="w-3.5 h-3.5" />Total Retur (kembali ke stok)</div><div className="text-2xl font-heading font-bold text-status-passed mt-1">{num(data?.total_return)}</div></div>
        <div className="bg-white border border-taupe/20 rounded-lg p-4"><div className="text-xs text-wmuted flex items-center gap-1.5"><Trash className="w-3.5 h-3.5" />Total Waste</div><div className="text-2xl font-heading font-bold text-status-rejected mt-1">{num(data?.total_waste)}</div></div>
      </div>
      <Panel>
        <Table>
          <TableHeader><TableRow className="hover:bg-transparent">
            <TableHead>Tanggal</TableHead><TableHead>Referensi</TableHead><TableHead>Kain</TableHead>
            <TableHead>Lot</TableHead><TableHead className="text-right">Qty</TableHead><TableHead>Jenis</TableHead><TableHead>Oleh</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {(data?.rows || []).map((r, i) => (
              <TableRow key={i} data-testid={`return-row-${i}`}>
                <TableCell className="text-sm">{fmtDate(r.datetime)}</TableCell>
                <TableCell className="font-mono text-xs">{r.reference}</TableCell>
                <TableCell className="font-medium text-cocoa">{r.material_name}</TableCell>
                <TableCell>{r.lot || "-"}</TableCell>
                <TableCell className="text-right">{num(r.qty)} {r.unit}</TableCell>
                <TableCell><span className={r.type === "Waste" ? "text-status-rejected" : "text-status-passed"}>{r.type}</span></TableCell>
                <TableCell className="text-sm">{r.user || "-"}</TableCell>
              </TableRow>
            ))}
            {!(data?.rows || []).length && <TableRow><TableCell colSpan={7} className="text-center text-wmuted py-10"><Recycle className="w-6 h-6 mx-auto mb-2 opacity-50" />Belum ada retur/waste kain.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Panel>
    </div>
  );
}
